<template>
  <modal v-on="$listeners">
    <template v-slot:header>{{ pageName }}</template>

    <!-- default slot -->
    <div class="flex flex-column min-modal-height">
      <div class="flex-auto flex flex-column justify-center">
        <div class="p2 center">
          <div>
            <input ref="fileinput" @change="fileUpdated" hidden id="file" type="file" accept="image/*,video/*,audio/*,.m4a;capture">

            <div v-if="!selectedFile" class="p3 center h6">
              <label class="block btn btn-rounded white bg-black p1 col-10 caps" for="file">
                Select from Library
              </label>
            </div>
            <div v-else>
              <figure :class="{ preview: !isAudio }">
                <video v-if="isVideo" @click="download(previewUrl, selectedFile.name)" :src="previewUrl" :type="this.fileType" autoplay muted loop/>
                <img v-else-if="isImage" @click="download(previewUrl, selectedFile.name)" :src="previewUrl">
                <audio v-else-if="isAudio" :src="previewUrl" controls loading="lazy" class="mb3 col-12"></audio>
              </figure>
              <field-note-form ref="form" :draft="draft" :file="selectedFile" @close="$emit('close')" type="media"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import FieldNoteForm from '@/components/FieldNoteForm'
  import { createObjectURL } from '@/util'

  export default {
    name: 'NewMedia',
    props: {
      draft: Object
    },
    data () {
      return {
        selectedFile: null,
        previewUrl: null
      }
    },
    computed: {
      pageName () {
        return this.draft ? 'Edit Note' : 'Take Photo'
      },
      isVideo () {
        if (!this.selectedFile) return
        return this.selectedFile.type &&
          this.selectedFile.type.includes('video')
      },
      isImage () {
        if (!this.selectedFile) return
        return this.selectedFile.type &&
          this.selectedFile.type.includes('image')
      },
      isAudio () {
        if (!this.selectedFile) return
        return this.selectedFile.type &&
          this.selectedFile.type.includes('audio')
      },
      fileType () {
        if (this.selectedFile) {
          return this.selectedFile.type
        } else if (this.draft) {
          return this.draft.fileType
        }
        return null
      }
    },
    methods: {
      fileUpdated ({ target }) {
        this.selectedFile = target.files[0]
        this.previewUrl = createObjectURL(this.selectedFile)
      },
      download (url, name = 'file') {
        let link = document.createElement('a')
        link.download = name
        link.href = url
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    created () {
      if (this.draft && this.draft.file) {
        this.selectedFile = this.draft.file
        this.previewUrl = this.draft.previewUrl
      }
    },
    mounted () {
      if (!this.draft) {
        this.$refs.fileinput.click()
      }
    },
    components: { FieldNoteForm }
  }
</script>

<style>
  .preview {
    display: block;
    margin: auto;
    width: 163px;
    height: 163px;
    margin-bottom: 30px;

    source, img, video {
      width: 100%;
      height: 100%;
      border-radius: 12px;
      object-fit: cover;
    }
  }
</style>
